import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'

import WarningText from '@/app/component/atom/warning-text'

type Props = {}

const ConnectMetaLoadingDialog: React.FC<Props> = () => {
  // prevent this browser tab/window from being closed
  React.useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()

      // legacy support for older browsers (Chrome/Edge < 119)
      event.returnValue = true
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return (
    <Dialog open>
      <DialogTitle>Connecting with Meta...</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          We're connecting your WhatsApp Phone Number to Meta. Please complete the registration process in the Meta
          popup.
        </Typography>
        <WarningText color="warning" sx={{ mt: 1 }}>
          <Typography fontWeight="bold" variant="subtitle2">
            Important: Please keep this browser tab/window open until the registration process is complete.
          </Typography>
        </WarningText>
      </DialogContent>
    </Dialog>
  )
}

export default ConnectMetaLoadingDialog
